export default function Hero() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/88ad53aeff7651dd00262b4e9fbc521d.jpg"
          alt="IT Infrastructure Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900/85 via-gray-900/70 to-teal-900/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 py-32 flex flex-col lg:flex-row items-center gap-16">
        {/* Left: Headline */}
        <div className="flex-1 text-center lg:text-left">
          <span className="inline-block px-4 py-1.5 rounded-full bg-teal-500/20 border border-teal-400/40 text-teal-300 text-xs font-semibold tracking-widest uppercase mb-6">
            Remote &amp; Onsite IT Support
          </span>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight tracking-tight mb-6">
            Expert IT Support,<br />
            <span className="text-teal-400">Wherever You Are</span>
          </h1>
          <p className="text-gray-300 text-lg md:text-xl leading-relaxed max-w-xl mx-auto lg:mx-0 mb-10">
            SilentNet delivers fast, reliable IT services for businesses and individuals — from remote troubleshooting to full onsite infrastructure management.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <button
              onClick={() => handleNav("#contact")}
              className="px-8 py-3.5 rounded-full bg-teal-500 text-white font-semibold text-base hover:bg-teal-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Get Free Consultation
            </button>
            <button
              onClick={() => handleNav("#services")}
              className="px-8 py-3.5 rounded-full border border-white/30 text-white font-semibold text-base hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Explore Services
            </button>
          </div>
        </div>

        {/* Right: Stats Cards */}
        <div className="flex-shrink-0 grid grid-cols-2 gap-4 w-full max-w-sm">
          {[
            { icon: "ri-customer-service-2-line", value: "24/7", label: "Remote Support" },
            { icon: "ri-shield-check-line", value: "99.9%", label: "Uptime Guarantee" },
            { icon: "ri-time-line", value: "&lt;2hr", label: "Response Time" },
            { icon: "ri-building-2-line", value: "500+", label: "Clients Served" },
          ].map((stat) => (
            <div
              key={stat.label}
              className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-2xl p-5 flex flex-col items-center text-center"
            >
              <div className="w-10 h-10 flex items-center justify-center text-teal-400 text-2xl mb-2">
                <i className={stat.icon} />
              </div>
              <div
                className="text-2xl font-bold text-white mb-1"
                dangerouslySetInnerHTML={{ __html: stat.value }}
              />
              <div className="text-gray-400 text-xs">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-white/50 animate-bounce">
        <span className="text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-lg" />
      </div>
    </section>
  );
}
